"use client";

import Link from "next/link";
import { Fragment } from "react";

const linkClassName =
  "font-mono text-foreground underline-offset-4 hover:underline";

export default function ToolExamples({
  label,
  examples,
  exampleHrefs,
  onSelect,
  getExampleHref,
  disabled,
}: {
  label: string;
  examples: string[];
  /** Pre-resolved hrefs (server components); same order as `examples`. */
  exampleHrefs?: string[];
  onSelect?: (value: string) => void;
  getExampleHref?: (value: string) => string;
  disabled?: boolean;
}) {
  if (examples.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 pt-1 text-sm">
      <span className="text-muted-foreground">{label}</span>
      {examples.map((example, index) => {
        const href = exampleHrefs?.[index] ?? getExampleHref?.(example);

        return (
        <Fragment key={example}>
          {index > 0 ? (
            <span className="text-muted-foreground" aria-hidden>·</span>
          ) : null}
          {href ? (
            <Link
              href={href}
              prefetch={false}
              className={linkClassName}
            >
              {example}
            </Link>
          ) : (
            <button
              type="button"
              disabled={disabled}
              onClick={() => onSelect?.(example)}
              className={`cursor-pointer ${linkClassName} disabled:cursor-not-allowed disabled:opacity-50`}
            >
              {example}
            </button>
          )}
        </Fragment>
        );
      })}
    </div>
  );
}
